import { render, staticRenderFns } from "./CourseCarousel.vue?vue&type=template&id=086b7be0&scoped=true&"
import script from "./CourseCarousel.vue?vue&type=script&lang=ts&"
export * from "./CourseCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./CourseCarousel.vue?vue&type=style&index=0&id=086b7be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086b7be0",
  null
  
)

export default component.exports